export default __webpack_public_path__ + "static/media/whatsApp.91b47dba.png";